<template>
  <div>
    <el-form label-width="100px">
      <el-form-item label="选择日期范围">
        <el-col :span="12">
          <el-date-picker
            v-model="vdate"
            type="daterange"
            alue-format="yyyy-MM-dd"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 100%;"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            @change="dateChange">
          </el-date-picker>
        </el-col>
        <el-col :span="12">
          <el-button type="primary" @click="exportData" v-loading="exportloading">导出</el-button>
            <el-popover
            placement="top-start"
            width="200"
            trigger="hover"
            content="导出任务会以队列执行，点击导出后，请至‘设置-导出列表’页面中查看及下载数据">
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </el-col>
      </el-form-item>
    </el-form>
    <el-tabs v-if="$route.path.indexOf('_editor') === -1" v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="退款统计" name="goods_count" v-loading="loading">
        <template>
          <el-table :data="allListData" stripe border style="width: 100%" :height="wheight-230">
            <el-table-column prop="order_id" label="订单号"></el-table-column>
            <el-table-column prop="trade_id" label="交易号"></el-table-column>
            <el-table-column prop="mobile" label="会员手机号"></el-table-column>
            <el-table-column prop="user_id" label="会员ID"></el-table-column>
            <el-table-column prop="create_date" label="时间"></el-table-column>
            <el-table-column prop="number" label="门店ID"></el-table-column>
            <el-table-column prop="distributor_name" label="门店名称"></el-table-column>
            <el-table-column prop="pay_type" label="支付方式"></el-table-column>
            <el-table-column prop="item_fee" label="订单总金额(不含运费)"></el-table-column>
            <el-table-column prop="freight_fee" label="运费"></el-table-column>
            <el-table-column prop="discount_fee" label="app优惠"></el-table-column>
            <el-table-column prop="isPush" label="推送药关爱">
              <template slot-scope="scope">
                  <span v-if="scope.row.isPush==0">否</span>
                  <span v-else>是</span>
              </template>
            </el-table-column>
            <el-table-column prop="total_fee" label="订单总金额(含运费)"></el-table-column>
          </el-table>
        </template>
      </el-tab-pane>
      <div class="content-padded content-center">
        <el-pagination
                background
                layout="total, sizes, prev, pager, next"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                :current-page.sync="params.page"
                :page-sizes="[10,20,50]"
                :total="total_count"
                :page-size="params.pageSize">
        </el-pagination>
      </div>
    </el-tabs>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import json2csv from 'json2csv'
  import { getRefundData } from '../../../api/datacube'
  export default {
    data () {
      return {
        vdate: '',
        loading: true,
        exportloading: false,
        total_count:0,
        activeName: 'goods_count',
        params: {
          start:new Date().getFullYear()+"-" + (new Date().getMonth()+1) + "-" + (new Date().getDate()-1),
          end: new Date().getFullYear()+"-" + (new Date().getMonth()+1) + "-" + (new Date().getDate()-1),
          page: 1,
          pageSize: 20,
        },
        allListData: [],
        // fields: ['item_bn', 'category_name', 'item_name', 'sales_count', 'fixed_amount_count', 'settle_amount_count'],
        fields: ['order_id','trade_id','mobile','user_id','create_date', 'number', 'distributor_name', 'pay_type', 'freight_fee', 'item_fee','total_fee','discount_fee'],
        pickerOptions: {
          shortcuts: [{
            text: '最近一天',
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          }]
        }
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      exportData () {
        this.exportloading = true
        this.params.export = 1
          getRefundData(this.params).then(res => {
          this.exportloading = false
          if (res.data.status) {
                    this.$message({
                        type: 'success',
                        message: '已加入执行队列，请在设置-导出列表中下载'
                    })
                    return
                } else if (res.data.url) {
                    this.downloadUrl = res.data.url
                    this.downloadName = res.data.filename
                    this.downloadView = true
                } else {
                  this.$message({
                      type: 'error',
                      message: '无内容可导出 或 执行失败，请检查重试'
                  })
                  return
                }

          // var exportdata = res.data.data.list
          // exportdata.unshift()
          // this.exportloading = false
          // var fileName = '商品数据'
          // try {
          //   const result = json2csv.parse(exportdata, {
          //     fields: this.fields
          //     // excelStrings: true,
          //   });
          //   if (this.MyBrowserIsIE()) {
          //     // IE10以及Edge浏览器
          //     var BOM = "\uFEFF";
          //     // 文件转Blob格式
          //     var csvData = new Blob([BOM + result], { type: "text/csv" });
          //     navigator.msSaveBlob(csvData, `${fileName}.csv`);
          //   } else {
          //     let csvContent = "data:text/csv;charset=utf-8,\uFEFF" + result;
          //     // 非ie 浏览器
          //     this.createDownLoadClick(csvContent, `${fileName}.csv`);
          //   }
          // } catch (err) {
          //   this.exportloading = false
          //   alert(err);
          // }
        }).catch( error => {
          this.exportloading = false
        })
      },
      createDownLoadClick(content, fileName) {
        const link = document.createElement("a");
        link.href = encodeURI(content);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      handleCurrentChange (page_num) {
          console.log(page_num);
          this.loading = false
          this.params.page = page_num
          this.getParams()
          this.getRefundData(this.params)
      },
      handleSizeChange (pageSize) {
          console.log(pageSize);
          this.loading = false
          this.params.page = 1
          this.params.pageSize = pageSize
          this.getParams()
          this.getRefundData(this.params)
      },
      getParams () {
          console.log(this.params.start)
          console.log(this.params.end)

          this.params.start = this.params.start
          this.params.end = this.params.end
      },
      MyBrowserIsIE() {
        let isIE = false;
        if (
          navigator.userAgent.indexOf("compatible") > -1 &&
          navigator.userAgent.indexOf("MSIE") > -1
        ) {
          // ie浏览器
          isIE = true;
        }
        if (navigator.userAgent.indexOf("Trident") > -1) {
          // edge 浏览器
          isIE = true;
        }
        return isIE;
      },
      handleClick (tab, event) {
      },
      dateChange (val) {
        if (!val) {
          return false
        }
        this.params.start = val[0]
        this.params.end = val[1]
        this.params.export = 0
        this.getRefundData()
      },
      getRefundData() {
        this.loading = true
          getRefundData(this.params).then(res => {
          this.allListData = res.data.data.list
          this.total_count = res.data.data.pager.count
          this.loading = false
        }).catch( error => {
          this.$message({
            type: 'error',
            message: '获取统计信息出错'
          })
        })
      },
    },
    mounted () {
      var start = new Date();
      var end = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
      this.vdate = [start, end]
      this.getRefundData()
    }
  }
</script>



// WEBPACK FOOTER //
// refunddata.vue?0d6dfe04